<template>
  <v-sheet>
    <v-form ref="form">
      <v-card-title>Google Place ID Lookup (find your business on Google)</v-card-title>
      <v-card-text class="modal-card-text">
        <v-sheet>
          <div>
            <input
              id="pac-input"
              class="controls"
              type="text"
              placeholder="Enter your business name"
            />
          </div>
          <div id="map"></div>
          <div id="infowindow-content">
            <span id="place-name" class="title"></span><br />
            <!-- <strong>Place ID:</strong> <span id="place-id"></span><br> -->
            <span id="place-address"></span>
            <v-btn
              color="primary tile mt-6 float-right"
              @click.prevent="setGooglePlaceId"
              >&nbsp;&nbsp;&nbsp;Set as my location&nbsp;&nbsp;&nbsp;</v-btn
            >
          </div>

          <script2>
            function initMap() { let map = new
            google.maps.Map(document.getElementById('map'), { center: {lat:
            30.275, lng: -97.740}, zoom: 12, mapTypeControl: false,
            fullscreenControl: false, streetViewControl: false, rotateControl:
            false }); if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
            initialLocation = new google.maps.LatLng(position.coords.latitude,
            position.coords.longitude); map.setCenter(initialLocation); }); }
            let input = document.getElementById('pac-input'); let autocomplete =
            new google.maps.places.Autocomplete(input);
            autocomplete.bindTo('bounds', map);
            autocomplete.setFields(['place_id', 'geometry', 'name',
            'formatted_address','type']);
            map.controls[google.maps.ControlPosition.TOP_LEFT].push(input); let
            infowindow = new google.maps.InfoWindow(); let infowindowContent =
            document.getElementById('infowindow-content');
            infowindow.setContent(infowindowContent); let marker = new
            google.maps.Marker({map: map}); setTimeout(function(){
            document.getElementById("pac-input").focus(); }, 2000);
            marker.addListener('click', function() { infowindow.open(map,
            marker); }); autocomplete.addListener('place_changed', function() {
            infowindow.close(); let place = autocomplete.getPlace(); if
            (!place.geometry) { return; } if (place.geometry.viewport) {
            map.fitBounds(place.geometry.viewport); } else {
            map.setCenter(place.geometry.location); } marker.setPlace({ placeId:
            place.place_id, location: place.geometry.location });
            marker.setVisible(true);
            infowindowContent.children['place-name'].textContent = place.name;
            infowindowContent.children['place-address'].textContent =
            place.formatted_address; infowindow.open(map, marker); googlePlaceId
            = place.place_id; googleCompanyName = place.name }); }
          </script2>
          <script2
            src="https://maps.googleapis.com/maps/api/js?key=AIzaSyC6PEKZx8fC19JPgn541R6pqr9sLfQto2c&libraries=places&callback=initMap"
            async
            defer
          ></script2>
        </v-sheet>
      </v-card-text>
    </v-form>
  </v-sheet>
</template>

<script>
// import { VALIDATION_RULES } from "../../../helpers/ValidationRules";

export default {
  name: "GooglePlaceIDLookupModal",
  props: {},
  data: function() {
    return {};
  },
  computed: {
    userId() {
      return this.$store.getters["entities/settings/query"]().first().userId;
    },
    user() {
      return this.$store.getters["entities/users/find"](this.userId);
    },
    reviewSettings() {
      return this.$store.getters["entities/bizReviewSettings"]().first();
    },
    reviewSettingsConfig() {
      const tempSettings = this.$store.getters[
        "entities/bizReviewSettings"
      ]().first();
      return tempSettings ? tempSettings.config : {};
    }
  },
  created() {},
  methods: {
    onClose() {
      this.$parent.$parent.$parent.$parent.googleLookupDialog = false;
    },
    setGooglePlaceId() {
      let vueThis = this;
      let newConfig = this.reviewSettingsConfig;
      newConfig["googlePlaceId"] = window.googlePlaceId;
      newConfig["customerName"] = window.googleCompanyName;
      this.$store.dispatch("entities/bizReviewSettings/update", {
        where: vueThis.reviewSettings.id,
        data: {
          isDirty: true,
          googlePlaceId: window.googlePlaceId,
          config: newConfig
        }
      });
      this.$store.dispatch(
        "entities/bizReviewSettings/updateBizReviewsSettings",
        vueThis.reviewSettings
      );
      this.onClose();
    }
  }
};
</script>

<style lang="stylus">
div.modal-card-text {
  height: calc(90vh - 8rem);
}
div.modal-card-sheet, div.modal-card-text .v-sheet {
  height: 100%;
}
#map {
  height: 100%;
}
.controls {
  background-color: #fff;
  border-radius: 1px;
  border: 1px solid transparent;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  font-family: Roboto;
  font-size: 1rem;
  font-weight: 300;
  height: 29px;
  margin-left: 17px;
  margin-top: 10px;
  outline: none;
  padding: 0 11px 0 13px;
  text-overflow: ellipsis;
  width: 400px;
}

.controls:focus {
  border-color: #4d90fe;
}
.title {
  font-size: 1rem;
  font-weight: bold;
}
#infowindow-content {
  display: none;
}
#map #infowindow-content {
  display: inline;
}

.pac-container {
    z-index: 2020 !important;
}
.set-location {
  float: right;
  margin: .5rem 0 0;
}

#reviewSettingsForm {
  padding: 0 1rem;
}
.modal-footer {
  padding: 1rem 0;
}
</style>
